import { FC } from "react";
import { StyledTableRow } from "./styled.table";

export const Row: FC = ({ children, ...rest }) => {
  return <StyledTableRow {...rest}>{children}</StyledTableRow>;
};
